export default __webpack_public_path__ + "static/media/BetLightOFF.b60125bc.png";